<template>
  <div class="recommend-div">
    <div class="recommend-con">
      <div class="div-block">
        <div class="recommend-title">
          <img src="@/assets/images/aifv/img18.png" class="recommend-icon" alt="">
          <div class="recommend-text">
            <span>推荐</span>
            <span class="col-txt">原因</span>
          </div>
        </div>
        <div class="recommend-txt">根据当前Carto Journey所处阶段与学习进度，推荐以下内容</div>
      </div>
      <div class="list-con">
        <div class="recommend-title">
          <img src="@/assets/images/aifv/img19.png" class="recommend-icon" alt="">
          <div class="recommend-text">
            <span>推荐</span>
            <span class="col-txt">内容</span>
          </div>
        </div>
        <div class="btm-list">
          <template v-if="recommendList && recommendList.length > 0">
            <div class="btm-item" v-for="(item, index) in recommendList" :key="index"
              @click="handleJumpRecommend(item, index, item.type)">
              <img :src="item && item.coverUrl" class="item-cover" alt="">
              <div class="item-con">
                <div class="item-title">{{ item && item.title }}</div>
                <div class="item-flex-btm">
                  <div class="item-txt" v-if="item.keynoteSpeaker">讲师：{{ item && item.keynoteSpeaker }}</div>
                  <div class="item-txt" v-else></div>
                  <div class="item-txt">
                    <img src="@/assets/images/home/search_view@2x.png" class="eyes" alt="">
                    {{ item && item.readNum }}
                  </div>
                </div>
                <template v-if="`${item.type}` === '2' && `${item.isUnlock}` === '1' && !item.myUnlock">
                  <div class="item-unlock">
                    <img src="@/assets/images/data-base/unlock.png" class="icon-unlock" alt="">
                    <span class="txt">{{ item && item.unlockCost }}积分解锁</span>
                  </div>
                </template>
              </div>
            </div>
          </template>
          <div class="empty-block" v-else>
            <img src="@/assets/images/zone/img18.png" class="empty-img" alt="" />
            <div class="empty-txt">暂无内容</div>
          </div>
        </div>
      </div>
    </div>
    <dialogUnlock ref="dialogUnlock" @unlockSuccess="handleJump" :dataProps="dataProps"></dialogUnlock>
  </div>
</template>
<script>
import { setSha, traceClickURL } from '@/utils/util'
import withRouteTracking from '@/utils/withRouteTracking'
import {isScorm} from '../../api/scorm'
const UserProfile = {
  name: 'Recommend',
  props: {
    recommendList: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  data () {
    return {
      dataProps: {
        unlockContent: '兑换EP公开课课程',
        unlockTxt: '课程'
      }
    }
  },
  methods: {
    handleJumpRecommend (item, index, type) {
      this.curIndex = index
      this.dataDetails = item
      this.typeTxt = type
      if (`${item.isUnlock}` === '1' && !item.myUnlock) {
        this.dataProps.baseId = item.baseId
        this.dataProps.unlockCost = item.unlockCost
        this.$refs.dialogUnlock.dailogShow = true
        return
      }
      this.handleJump()
    },
    async handleJump () {
      sessionStorage.setItem('entrance', '57')
      let item = this.dataDetails
      // let openid = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
      let trackParams = `&entrance=57&businessChannel=57`
      let openidBindli = `&unionid=${this.userInfo.unionId}&openid=${this.userInfo.iepOpenId}${setSha(`xxbiep${this.userInfo.iepOpenId}`)}`
      // let iepTxt = `&nickname=123&avatar=123&subscribe=1`
      if (item.type === 1) {
        this.$router.push({
          path: '/articleDetails',
          query: {
            id: item.baseId,
            entrance: 57,
            channel: 57,
          }
        })
        // setTimeout(() => { traceClickURL() })
        // window.location.href = `${process.env.iepUrl}/mobile/home/article-detail?index=0&id=${item.baseId}${openid}${iepTxt}${trackParams}`
      } else if (item.type === 3) {
        setTimeout(() => { traceClickURL() })
        window.location.href = `${process.env.bingliUrl}/wap/index.html#/casedetails?id=${item.baseId}${openidBindli}${trackParams}`
      } else if (item.type === 2) {
        const query = {
          courseId: item.baseId,
          sectionId: item.sectionId,
          entrance: '57',
          channel: '57'
        }
        const isscorm = await isScorm(item.baseId)
        let path = '/courserDetails'
        if (isscorm.data) {
          path = '/scormCourseDetail'
        }
        this.$router.push({path, query})
      }
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.recommend-div {
  background: #F9F8F7;
  padding: 16px;
  height: 100vh;
  box-sizing: border-box;

  .recommend-con {
    height: 100%;
    width: 100%;
    padding: 16px;
    box-sizing: border-box;
    background-color: #fff;
    border-radius: 12px;

    .div-block {
      background: #F9F8F7;
      width: 100%;
      height: 112px;
      display: block;
      padding: 30px 24px;
      box-sizing: border-box;
      border-radius: 12px;

      .recommend-txt {
        margin-top: 10px;
        color: rgba(0, 0, 0, .6);
        font-size: 14px;
        font-family: Source Han Sans CN, Source Han Sans CN;
      }
    }
  }

  .recommend-title {
    display: flex;
    align-items: center;

    .recommend-icon {
      height: 14px;
      display: block;
      margin-right: 3px;
    }

    .recommend-text {
      display: flex;
      align-items: center;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 600;
      font-size: 14px;
      color: #000000;

      .col-txt {
        color: #EB1700;
      }
    }
  }

  .list-con {
    padding: 12px 16px;
    box-sizing: border-box;
  }
}

.btm-list {
  .btm-item {
    display: flex;
    margin-top: 16px;

    .item-con {
      width: 180px;
    }

    .item-cover {
      width: 114px;
      height: 65px;
      border-radius: 6px;
      margin-right: 13px;
    }

    .item-con {
      .item-title {
        font-size: 14px;
        color: #333333;
        font-weight: 500;
        line-height: 20px;
        overflow: hidden; //溢出内容隐藏
        text-overflow: ellipsis; //文本溢出部分用省略号表示
        display: -webkit-box; //特别显示模式
        -webkit-line-clamp: 2; //行数
        line-clamp: 2;
        -webkit-box-orient: vertical; //盒子中内容竖直排列
        margin-bottom: 4px;
      }

      .item-flex-btm {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

      .item-txt {
        font-size: 12px;
        color: #B1B1B1;
        display: flex;
        align-items: center;

        .eyes {
          width: 16px;
          display: block;
          margin-right: 4px;
        }
      }
    }
  }

  .item-unlock {
    display: flex;
    align-items: center;
    height: 20px;
    margin-top: 2px;

    .icon-unlock {
      width: 10px;
      margin-right: 4px;
      display: block;
    }

    .txt {
      color: #EB1700;
      font-size: 12px;
    }
  }
}

.empty-block {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding-top: 20px;
  padding-bottom: 20px;

  .empty-img {
    width: 185px;
    display: block;
    margin-bottom: 4px;
  }

  .empty-txt {
    font-size: 12px;
    color: #949ba5;
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/AIFV/recommend.vue